import UserData from './user-data';

export default UserData;
